import { render, staticRenderFns } from "./modalAddSocialMilestone.vue?vue&type=template&id=374441a1&"
import script from "./modalAddSocialMilestone.vue?vue&type=script&lang=js&"
export * from "./modalAddSocialMilestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports